import { message as antMessage } from 'antd';

export const message = {
  info: (...args) => antMessage.info(...args),
  success: (...args) => antMessage.success(...args),
  warning: (...args) => antMessage.warning(...args),
  error: (...args) => antMessage.error(...args),
};
